import React from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from './Navigation';
import { MiniPlayer } from './MiniPlayer';
import { LanguageSelector } from './LanguageSelector';
import { useAudioStore } from '@/hooks/useAudioStore';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const { currentStation } = useAudioStore();
  // Full player sheet + Listen tab (/app) already show station UI — hide floating mini.
  const isFullPlayer = location.pathname === '/app/player';
  const isListenTab = location.pathname === '/app';
  const hideMiniPlayer = isFullPlayer || isListenTab;
  const showNav = !isFullPlayer;
  const showMiniPlayer = Boolean(currentStation) && !hideMiniPlayer;

  // LanguageSelector na Impressum, Datenschutz i postavkama (na News je u hero headeru)
  const showLanguageSelector =
    location.pathname === '/impressum' ||
    location.pathname === '/datenschutz' ||
    location.pathname === '/app/settings';

  return (
    <div className="min-h-screen text-text-primary relative overflow-hidden">
      {showLanguageSelector && (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[100]">
          <LanguageSelector />
        </div>
      )}
      {/* Animated smoke background */}
      <div
        className="fixed inset-0 bg-cover bg-center bg-no-repeat bg-smoke-animated"
        style={{
          backgroundImage: 'url(/bg-smoke.png)',
          height: '115%',
          top: '-7.5%',
        }}
        aria-hidden
      />
      {/* Overlay za čitljivost sadržaja */}
      <div className="fixed inset-0 bg-primary-bg/50" aria-hidden />
      <main
        className={`relative z-10 ${isFullPlayer ? '' : showMiniPlayer ? 'pb-36' : 'pb-24'}`}
      >
        {children}
      </main>
      {showMiniPlayer && <MiniPlayer />}
      {showNav && <Navigation />}
    </div>
  );
};
